import React, { useState, useEffect, Fragment } from "react";
import services from "../services";
import { CardSuspendFilteringSchema } from "../CardSuspendSchema";
import { EmployeeCardSuspendListing } from "../Pages/listing";
import { PageHeader } from "../../../../Common";
import { validateProperty, validate } from "../../../Common";
import Joi from "@hapi/joi";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import authService from "../../../Common/services";
import tokenService from "../../../../Common/tokenDecoder";
import { trackPromise } from "react-promise-tracker";
import { LoadingSpinerComponent } from "../../../../Common/loader";

const screenCode = "EMPLOYEECARDSUSPEND";

export function EmployeeCardSuspendFiltering(props) {
  const [title, setTitle] = useState("Employee Suspend Cards");
  const [operationEntities, setOperationEntities] = useState([]);
  const [operationEntity, setOperationEntity] = useState([]);
  const [multipleEstates, setMultipleEstates] = useState([]);
  const [groups, setGroups] = useState();
  const [collectionPoint, setCollectionPoint] = useState([]);
  const [cardSuspendData, setCardSuspendData] = useState([]);
  const [cardSuspendFilter, setCardSuspendFilter] = useState({
    cardNumber: "",
    collectionPointID: "0",
    firstName: "",
    groupID: "0",
    nameToBePrinted: "",
    operationEntityID: "0",
    registrationNumber: "",
    remark: "",
    employeeTypeID: "0",
    isRsm: false
  });
  const [errors, setErrors] = useState({});
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isOperationEntityFilterEnabled: false,
  });
  const schema = Joi.object(CardSuspendFilteringSchema).options({
    allowUnknown: true,
  });
  const [employeeTypes, setEmployeeTypes] = useState([]);

  useEffect(() => {
    getPermissions();
  }, []);

  useEffect(() => {
    trackPromise(getOperationEntityForDropdown());
  }, [cardSuspendFilter.groupID]);

  useEffect(() => {
    trackPromise(getCollectionPointForDropDown());
  }, [cardSuspendFilter.operationEntityID]);

  useEffect(() => {
    setCardSuspendData([]);
  }, [cardSuspendFilter.operationEntityID]);

  useEffect(() => {
    setCardSuspendData([]);
  }, [cardSuspendFilter.collectionPointID]);

  useEffect(() => {
    setCardSuspendData([]);
  }, [cardSuspendFilter.employeeTypeID]);

  useEffect(() => {
    setCardSuspendData([]);
  }, [cardSuspendFilter.isRsm]);

  async function getGroupsForDropdown() {
    const result = await services.getAlGroupsForDropdown();
    setGroups(result);
  }

  async function getOperationEntityForDropdown() {
    const operationEntityList = await services.getOperationEntitiesByGroupForDropDown(cardSuspendFilter.groupID);
    setOperationEntity(operationEntityList);
  }

  async function getCollectionPointForDropDown() {
    const collectionPoint = await services.GetCollectionPointsFilter(cardSuspendFilter.operationEntityID);
    setCollectionPoint(collectionPoint);
  }

  async function getPermissions() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(
      (p) => p.permissionCode == "VIEWEMPLOYEECARDSUSPENDLISTING"
    );

    if (isAuthorized === undefined) {
      props.history.push("/unauthorized");
    }

    var isGroupFilterEnabled = permissions.find(
      (p) => p.permissionCode == "GROUPDROPDOWN"
    );
    var isOperationEntityFilterEnabled = permissions.find(
      (p) => p.permissionCode == "OPERATIONENTITYDROPDOWN"
    );

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isOperationEntityFilterEnabled:
        isOperationEntityFilterEnabled !== undefined,
    });

    var token = tokenService.getUserDetailsFromTokenV2();

    if (token.operationEntities.length > 0) {

      var estateArray = [];
      for (let item of Object.entries(token.operationEntities)) {
        estateArray[item[1]["OperationEntityID"]] = item[1]["OperationEntityName"]
      }

      setMultipleEstates(estateArray)

    }


    setCardSuspendFilter({
      ...cardSuspendFilter,
      groupID: token.groupID,
      operationEntityID: token.operationEntityID,
    });

    trackPromise(getGroupsForDropdown());
    trackPromise(getEmployeeTypesForDropdown())
  }

  function handleGroupChange(target) {
    validateInputs(target);

    setCardSuspendFilter({
      ...cardSuspendFilter,
      groupID: target.value,
      operationEntityID: "0",
      collectionPointID: "0",
    });
  }

  function handleOperationEntityChange(target) {
    validateInputs(target);

    setCardSuspendFilter({
      ...cardSuspendFilter,
      operationEntityID: target.value,
      collectionPointID: "0",
    });
  }

  function handleCollectionPointChange(target) {
    validateInputs(target);

    setCardSuspendFilter({
      ...cardSuspendFilter,
      collectionPointID: target.value,
      employeeTypeID: "0"
    });
  }

  function validateInputs(target) {
    const error = { ...errors };
    const errorMessage = validateProperty(target, CardSuspendFilteringSchema);
    errorMessage
      ? (error[target.name] = errorMessage)
      : delete error[target.name];

    setErrors(error);
  }

  async function handleSearch(e) {
    e.preventDefault();

    const errorMessages = validate(schema, cardSuspendFilter);
    errorMessages !== null ? setErrors(errorMessages) : setErrors({});
    if (errorMessages) return;

    const response = await services.getCardSuspendDetails(
      cardSuspendFilter.collectionPointID, cardSuspendFilter.employeeTypeID, cardSuspendFilter.isRsm
    );
    setCardSuspendData(response);
  }

  function generateDropDownMenu(data) {
    let items = [];
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(
          <MenuItem key={key} value={key}>
            {value}
          </MenuItem>
        );
      }
    }
    return items;
  }
  async function afterSuccessfulyChanged() {
    const response = await services.getCardSuspendDetails(cardSuspendFilter.collectionPointID, cardSuspendFilter.employeeTypeID, cardSuspendFilter.isRsm);
    setCardSuspendData(response);
  }
  function clearState() {
    setCardSuspendFilter({
      ...cardSuspendFilter,
      collectionPointID: "0",
      employeeTypeID: "0"
    });
    setCardSuspendData([]);
  }

  function onCancelClick() {
    clearState();
  }

  async function getEmployeeTypesForDropdown() {
    const result = await services.GetAllEmployeeTypes();
    setEmployeeTypes(result);
  }

  function handleEmployeeTypeChange(target) {
    validateInputs(target);

    setCardSuspendFilter({
      ...cardSuspendFilter,
      employeeTypeID: target.value

    })
  }

  function handleChange(e) {
    setCardSuspendFilter({
      ...cardSuspendFilter,
      isRsm: e.target.checked
    })
  }

  return (
    <Fragment>
      <LoadingSpinerComponent />
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <PageHeader title={title} />
              </div>
              <form onSubmit={(e) => handleSearch(e)} disabled={false}>
                <div className="form-group row">
                  <div className="col-md pb-1">
                    <InputLabel shrink id="groupID">
                      Group *
                    </InputLabel>
                    <Select
                      fullWidth
                      id="groupID"
                      name="groupID"
                      value={cardSuspendFilter.groupID}
                      disabled={!permissionList.isGroupFilterEnabled}
                      onChange={(e) => handleGroupChange(e.target)}
                    >
                      <MenuItem value="0">--Select Group--</MenuItem>
                      {generateDropDownMenu(groups)}
                    </Select>
                    {errors["groupID"] && (
                      <FormHelperText error>{errors["groupID"]}</FormHelperText>
                    )}
                  </div>

                  <div className="col-md pb-1">
                    <InputLabel shrink id="operationEntityID">
                      Operation Entity *
                    </InputLabel>
                    <Select
                      fullWidth
                      id="operationEntityID"
                      name="operationEntityID"
                      value={cardSuspendFilter.operationEntityID}
                      disabled={!permissionList.isOperationEntityFilterEnabled}
                      onChange={(e) => handleOperationEntityChange(e.target)}
                    >
                      <MenuItem value="0">--Select Operation Entity--</MenuItem>
                      {generateDropDownMenu(
                        Object.fromEntries(
                          Object.entries(operationEntity).filter(([key, value]) => {
                            if (key === "0" || !value) return false;
                            if (!multipleEstates || Object.keys(multipleEstates).length === 0) {
                              return true;
                            }
                            return Object.values(multipleEstates).includes(value);
                          })
                        )
                      )}
                    </Select>
                    {errors["operationEntityID"] && (
                      <FormHelperText error>
                        {errors["operationEntityID"]}
                      </FormHelperText>
                    )}
                  </div>

                  <div className="col-md">
                    <InputLabel shrink id="collectionPointID">
                      Collection Point *
                    </InputLabel>
                    <Select
                      fullWidth
                      labelId="collectionPointID"
                      id="collectionPointID"
                      name="collectionPointID"
                      value={cardSuspendFilter.collectionPointID}
                      onChange={(e) => handleCollectionPointChange(e.target)}
                    >
                      <MenuItem value="0">--Select Collection Point--</MenuItem>
                      {generateDropDownMenu(collectionPoint)}
                    </Select>
                    {errors["collectionPointID"] && (
                      <FormHelperText error>
                        {errors["collectionPointID"]}
                      </FormHelperText>
                    )}
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-md-4 pb-1">
                    <InputLabel shrink id="employeeTypeID">
                      Employee Type *
                    </InputLabel>
                    <Select
                      fullWidth
                      labelId="employeeTypeID"
                      id="employeeTypeID"
                      name="employeeTypeID"
                      value={cardSuspendFilter.employeeTypeID}
                      onChange={(e) => handleEmployeeTypeChange(e.target)}
                    >
                      <MenuItem value="0">--Select Employee Type--</MenuItem>
                      {generateDropDownMenu(employeeTypes)}
                    </Select>
                    {errors["employeeTypeID"] && (
                      <FormHelperText error>
                        {errors["employeeTypeID"]}
                      </FormHelperText>
                    )}
                  </div>
                </div>
                <label>Is Rsm</label>
                <div className="form-group row">
                  <div className="col-md-4 pb-1">
                    <input
                      className="mr-2"
                      id="isRsm"
                      switch="none"
                      type="checkbox"
                      name="isRsm"
                      onChange={(e) => handleChange(e)}
                    />
                    <label
                      htmlFor="isRsm"
                      data-on-label="Yes"
                      data-off-label="No"
                    ></label>
                  </div>
                </div>

                <div className="card-footer">
                  <input
                    type="submit"
                    className="btn btn-primary"
                    value="Search"
                  />
                  <input
                    type="button"
                    className="btn btn-warning pull-right"
                    value="Clear"
                    onClick={onCancelClick}
                  />
                </div>

                <EmployeeCardSuspendListing
                  cardSuspendData={cardSuspendData}
                  afterSuccessfulyChanged={afterSuccessfulyChanged}
                />
              </form>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
